import * as utils from './index.js'
//0-100整数
export function validate100Int(rule, value, callback) {
  let str = utils.validate100Int(value)
  if (value) {
    if (!str) {
      return callback(new Error('请输入0-100的整数'));
    }
  }
  return callback()
}
//0-100000000整数
export function validateInt(rule, value, callback) {
  let str = utils.validateInt(value)
  if (value) {
    if (!str) {
      return callback(new Error('请输入整数'));
    }
  }
  return callback()
}


//整数或两位小数
export function validateIntOrTwoNum(rule, value, callback) {
  let str = utils.validateIntOrTwoNum(value)
  if (value) {
    if (!str) {
      return callback(new Error('请输入整数或两位小数'));
    }
  }
  return callback()
}

//百分数两位小数
export function validatePercent(rule, value, callback) {
  let str = utils.validatePercent(value)
  if (value) {
    if (!str) {
      return callback(new Error('请输入百分数'));
    }
  }
  return callback()
}



// WEBPACK FOOTER //
// ./src/utils/form.js